function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * シーケンス　モデル
 */
var SequenceInstanceModel =
/**
 * コンストラクタ
 *
 * @param groupNo グループ番号
 * @param no 番号
 */
function SequenceInstanceModel(groupNo, no) {
  _classCallCheck(this, SequenceInstanceModel);

  this.GroupNo = groupNo;
  this.No = no;
  this.Triggers = [];
  this.Actions = [];
  this.Memo = "";
  this.hasChange = false;
};

export { SequenceInstanceModel as default };